import { render, staticRenderFns } from "./CharactersSliderBullets.vue?vue&type=template&id=380f2146&"
import script from "./CharactersSliderBullets.vue?vue&type=script&lang=js&"
export * from "./CharactersSliderBullets.vue?vue&type=script&lang=js&"
import style0 from "./CharactersSliderBullets.vue?vue&type=style&index=0&id=380f2146&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports